import axios from '@/plugins/axios';

const initialState = () => {
    return {
        settings: localStorage.getItem('userSettings')
            ? JSON.parse(localStorage.getItem('userSettings'))
            : null
    };
};

const state = () => initialState();

const getters = {
    getSettings: state => state.settings
};

const mutations = {
    setSettings: (state, settings) => {
        state.settings = settings;

        if (!settings || typeof settings !== 'object') {
            return;
        }

        localStorage.setItem('userSettings', JSON.stringify(settings));
    },
    clearState: state => {
        localStorage.removeItem('userSettings');
        state.settings = null;
    }
};

const actions = {
    async save({ commit }, settings) {
        const { data } = await axios.put('/settings', settings);

        commit('setSettings', data);

        return data;
    },

    async searchTimezones(vuexCtx, search) {
        const { data } = await axios.get('/timezones', { params: { search } });

        return data;
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
